var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.feePrice
        ? [_c("br"), _vm._v("Listing Fee: " + _vm._s(_vm.feePrice) + "\n  ")]
        : _vm._e(),
      _vm._v(" "),
      _vm.shippingPrice
        ? [
            _c("br"),
            _vm._v("Logistic Fee: " + _vm._s(_vm.shippingPrice) + "\n  "),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.totalPrice
        ? [_c("br"), _vm._v("Total Fees: " + _vm._s(_vm.totalPrice) + "\n  ")]
        : _vm._e(),
      _vm._v(" "),
      _vm.fee.payment
        ? [
            _c("br"),
            _c("strong", { staticClass: "text-success" }, [_vm._v("Paid:")]),
            _vm._v(" " + _vm._s(_vm.paidAt) + "\n    "),
            _vm.fee.payment.payment_method === "auth_net"
              ? [
                  _c("br"),
                  _vm._v("Payment Method: Authorize.Net\n      "),
                  _c("br"),
                  _vm._v(
                    "Card: " +
                      _vm._s(_vm.fee.payment.card.brand) +
                      " ending in " +
                      _vm._s(_vm.fee.payment.card.ending) +
                      "\n      "
                  ),
                  _c("br"),
                  _vm._v(
                    "Transaction ID: " +
                      _vm._s(_vm.fee.payment.transaction_id) +
                      "\n      "
                  ),
                  _c("br"),
                  _vm._v(
                    "Auth Code: " +
                      _vm._s(_vm.fee.payment.auth_code) +
                      "\n      "
                  ),
                  _c("br"),
                  _vm._v(
                    "Response Code: " +
                      _vm._s(_vm.fee.payment.response_code) +
                      "\n    "
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _c("br"),
            _c("strong", { staticClass: "text-danger" }, [_vm._v("Not Paid")]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }